<template>
  <div class="mbti-home-container">
    <!-- 顶部背景几何装饰图案 -->
    <div class="bg-decoration shape-1"></div>
    <div class="bg-decoration shape-2"></div>

    <!-- 顶部导航栏 (模拟微信小程序头部) -->
    <div class="nav-bar">
      <i class="el-icon-arrow-left back-icon" @click="goBack()"></i>
      <span class="title">MBTI性格测试</span>
      <div class="capsule"></div>
    </div>

    <!-- 头部信息区 -->
    <div class="hero-section">
      <h1 class="main-title">#MBTI测评</h1>

      <div class="badge-wrapper">
        <span class="badge">93题专业版</span>
        <span class="badge-decoration"></span>
      </div>

      <p class="subtitle">
        让我们来看看你是哪种人格吧！<br />
        请以真实的自己诚实回答。
      </p>

      <button class="start-btn" @click="handleStart">
        开始测评 <i class="el-icon-right"></i>
      </button>
    </div>

    <!-- 白色内容卡片 -->
    <div class="content-card">
      <h2 class="section-title">MBTI测评</h2>
      <p class="text-paragraph">
        MBTI职业性格测试是国际最为流行的职业人格评估工具，能够让人们更好的认识和了解自己，可以帮助HR部门对不同类型的员工进行更好的组合。
      </p>
      <p class="text-paragraph">
        在MBTI系统中，不同性格类型之间没有好坏优劣之分，与工作能力和道德水准无关，测评只是帮助你了解自己的性格类型，答题时请按照真实的自己而不是期待中的自己。针对每一道问题无需过分思考，遇到一些觉得很纠结，无法取舍的问题是正常的，尽可能选择你在放松时最可能的倾向。
      </p>

      <h2 class="section-title">科学依据</h2>
      <p class="text-paragraph">
        MBTI人格理论的基础是著名心理学家卡尔·荣格先生关于心理类型的划分，后由美国的心理学家Katharine
        Cook Briggs 与Isabel Briggs Myers研究并加以发展(MBTI-Myers-Briggs
        TypeIndicator)MBTI测试是一种迫选型、自我报告式的性格评估测试，用以衡量和描述人们在获取信息、作出决策、对待生活等方面的心理活动规律和性格类型。
      </p>
      <p class="text-paragraph">
        在MBTI模型中，将人格分为四个维度，动力(将注意力集中在何处，从哪里获得动力)、信息收集(获取信息的方式)、决策方式(做决定的方法)做事方式(通过认知的过程或判断的过程)，每个维度有两个方向，共计八个方面，分别是:外向(E)和内向(I)、感觉(S)和直觉(N)、思考(T)和情感(F)、判断(J)和知觉(P)。
      </p>
      <p class="text-paragraph">
        每个人的性格都落足于四种维度每一种中点的这一边或那一边，我们把每种维度的两端称做“偏好”例如:如果你落在外向的那一边，那么就可以说你具有外向的偏好。如果你落在内向的那一边，那么就可以说你具有内向的偏好。
      </p>
      <p class="text-paragraph">
        四个维度，两两组合，共有十六种类型，以各个维度的字母组合来表示性格类型，如下:ESFP、ISFP、ENFJ、ENFP、ESTP、ISTP、INFJ、INFP、ESFJ、ISFJ、ENTP、INTP、ESTJ、ISTJ、ENTJ、INTJ。
      </p>

      <!-- 表格图片占位 (注意：请替换为真实的图片路径) -->
      <!-- 例如：<img src="@/assets/images/mbti-table.png" class="mbti-table-img" alt="MBTI类型表" /> -->
      <img
        src="@/assets/images/mbti-table.png"
        class="mbti-table-img"
        alt="MBTI表格"
      />

      <p class="text-paragraph">
        MBTI可以有效地评估我们的性格类型，帮助我们认清自己，测评只是探索自我的第一步，不可将结论强加于人;MBTI引导我们建立自信，信任并理解他人;进而在职业定位和发展、团队建设、领导力人格基础发展、人际工作关系、员工素质、组织内部沟通以及跨文化企业管理等领域为我们提供前所未有的帮助。
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "MbtiHome",
  methods: {
    handleStart() {
      // 点击开始测评按钮的逻辑
      console.log("开始测评");
      this.$router.push("/mbti-qa");
    },
    goBack() {
      this.$router.push("/mbti-home");
    },
  },
};
</script>

<style scoped>
/* 基础容器 */
.mbti-home-container {
  max-width: 480px;
  margin: 0 auto;
  /* 还原背景渐变色 */
  background: linear-gradient(180deg, #fdf0d5 0%, #f9be6c 100%);
  min-height: 100vh;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", Arial, sans-serif;
  position: relative;
  overflow: hidden; /* 防止背景图案溢出 */
  padding-bottom: 20px;
}

/* 模拟背景几何图案 */
.bg-decoration {
  position: absolute;
  background: rgba(255, 255, 255, 0.2);
  transform: rotate(45deg);
  z-index: 0;
}
.shape-1 {
  width: 150px;
  height: 150px;
  top: 80px;
  left: -50px;
}
.shape-2 {
  width: 200px;
  height: 200px;
  top: 120px;
  right: -80px;
}

/* 头部信息区 */
.hero-section {
  position: relative;
  z-index: 10;
  text-align: center;
  padding: 30px 20px 20px;
}

.main-title {
  font-size: 32px;
  font-weight: 900;
  color: #f39c12;
  margin: 0 0 15px 0;
  letter-spacing: 1px;
  /* 增加轻微文字阴影使其更立体 */
  text-shadow: 1px 1px 2px rgba(255, 255, 255, 0.5);
}

/* 标签样式 */
.badge-wrapper {
  position: relative;
  display: inline-block;
  margin-bottom: 25px;
}
.badge {
  background: #fff;
  color: #f39c12;
  padding: 4px 16px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: bold;
  box-shadow: 0 2px 8px rgba(243, 156, 18, 0.15);
  position: relative;
  z-index: 2;
}
/* 标签右侧的小方块装饰 */
.badge-decoration {
  position: absolute;
  width: 8px;
  height: 8px;
  background: #fff;
  right: -12px;
  top: 50%;
  transform: translateY(-50%);
  opacity: 0.8;
}

.subtitle {
  color: #d35400;
  font-size: 15px;
  line-height: 1.6;
  margin: 0 0 30px 0;
  font-weight: 500;
}

/* 开始按钮 */
.start-btn {
  background: linear-gradient(90deg, #ffca28, #ffa000);
  color: #fff;
  border: none;
  border-radius: 30px;
  padding: 14px 0;
  width: 70%;
  font-size: 18px;
  font-weight: bold;
  box-shadow: 0 6px 15px rgba(255, 160, 0, 0.3);
  cursor: pointer;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}
.start-btn i {
  margin-left: 8px;
  font-size: 18px;
}
.start-btn:active {
  transform: scale(0.98);
  box-shadow: 0 3px 8px rgba(255, 160, 0, 0.3);
}

/* 白色内容卡片 */
.content-card {
  position: relative;
  z-index: 10;
  background: #fff;
  border-radius: 20px;
  margin: 0 15px;
  padding: 30px 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
}

.section-title {
  text-align: center;
  font-size: 18px;
  color: #333;
  margin: 0 0 20px 0;
  font-weight: bold;
}

.text-paragraph {
  font-size: 14px;
  color: #666;
  line-height: 1.8;
  text-align: justify;
  margin: 0 0 15px 0;
}

/* 占据全宽的图片 */
.mbti-table-img {
  width: 100%;
  height: auto;
  display: block;
  margin: 20px 0;
  border-radius: 8px;
  /* 如果图片本身没有边框，可以加一点微弱的阴影 */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.03);
}
</style>
